export const HookCancel = Symbol.for('HookCancel');
